import { createAsyncThunk } from "@reduxjs/toolkit"
import { createAction } from "@reduxjs/toolkit";
import { request } from "../../utils/commonApi"
import { arcgisBaseURL } from "../../utils/layers"

export const initializeCesium = createAction('CESIUM_INITIALIZE');
export const focusOnHome = createAction('FOCUS_ON_HOME');
export const focusOnSelectedEntity = createAction('FOCUS_ON_SELECTED_ENTITY');

export const getLayersDescription = createAsyncThunk(
    'layer/getLayersDescription',
    async () => {
      const response = await request(arcgisBaseURL + '/arcgis/rest/services/Sur1/Sur/FeatureServer/layers?f=pjson')
      return response;
    },
)